import { inject, Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { ThesaurusPayload } from '@interfaces/thesaurus-payload.interface';
import { getEnvironment } from 'app/app.module';
import { TermsService } from '@terms-service/terms.service';
import { EventsService } from '../events/events.service';
import { catchError, map, Observable, tap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { data } from 'jquery';

const THESAURUS_GATEWAY_URL = `/thesaurus-gateway/sendmessage`;

const socketIoHost = `https://eventserver${getEnvironment()}.proquest.com/thesaurus`;
//    const socketIoHost = `http://localhost:3000/thesaurus`;

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  termsService: TermsService = inject(TermsService);
  eventsService = inject(EventsService);
  constructor(
        private http: HttpClient
  ) { 
    
  }

  sendMessageDirectToEventServer(message: ThesaurusPayload, token: string, closePopup: boolean): void {
    const socket = io(`${socketIoHost}`, {
      withCredentials: true,
      auth: {
        token: token
      }
    });

    socket.on('thesaurus-receive-ack', data => {
      socket.disconnect();
      if(closePopup) {
        window.close();
      } else {
        this.eventsService.emitShowBannerEvent(message.terms.length > 1);
        this.termsService.clearList();
      }
    });

   socket.on('connect', function() {
    
        // wait for server response before disconnecting
      socket.emit('thesaurus-send', message);
    });
  }
  
  sendMessageToAppServer(message: ThesaurusPayload, token: string, closePopup: boolean): Observable<string> {
    var jsonMessage = JSON.stringify(message);
    var url = `${THESAURUS_GATEWAY_URL}?token=${token}`;

    const socket = io(`${socketIoHost}`, {
      withCredentials: true,
      auth: {
        token: token
      }
    });

    socket.on('thesaurus-receive-ack', data => {
      socket.disconnect();
      if(closePopup) {
        window.close();
      } else {
        this.eventsService.emitShowBannerEvent(message.terms.length > 1);
        this.termsService.clearList();
      }
    });

    // Use HTTP POST to send the message to the backend which will then use WebSocket to send it to the parent window 
    return this.http.post<string>(
      url, jsonMessage, {
        headers: new HttpHeaders({
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }), 
        observe: "response",
   }).pipe(
      tap(response => console.log(`response=${response}`)),
      catchError(this.handleError)
    );
  }

  handleError(error: Response): Observable<any> {
    console.error("observable error: ", error);
    return throwError(error.statusText);
  }
}
function throwError(statusText: string): Observable<any> {
  throw new Error('Function not implemented.');
}

